import Vue from 'vue'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'
import VueAxiosPlugin from './customer/plugin/vue-axios'
import loadingImgUrl from '../images/lazyload/loading.png'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import smoothscroll from 'smoothscroll-polyfill'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import utc from 'dayjs/plugin/utc'
import timeZone from 'dayjs/plugin/timezone'

export default {
  start: () => {
    smoothscroll.polyfill()

    dayjs.extend(isSameOrBefore)
    dayjs.extend(utc)
    dayjs.extend(timeZone)
    dayjs.tz.setDefault('Asia/Tokyo')

    Vue.use(VueLazyload, {
      selector: 'img',
      preLoad: 1.1,
      loading: loadingImgUrl,
      error: 'https://dummyimage.com/500x500/ccc/999.png&text=error'
    })

    Vue.use(VueAxiosPlugin, { axios })

    Vue.directive('scroll', {
      bind(el, binding) {
        el.addEventListener('scroll', _.debounce(binding.value, 100))
      },
      unbind(el, binding) {
        el.removeEventListener('scroll', _.debounce(binding.value, 100))
      }
    })

    Vue.directive('resize', {
      bind(el, binding) {
        // resize の発火頻度を調整している
        // ref: https://jp.vuejs.org/v2/guide/computed.html#%E3%82%A6%E3%82%A9%E3%83%83%E3%83%81%E3%83%A3
        // ref: https://webman-japan.com/vue-event-resize/
        window.addEventListener('resize', _.debounce(binding.value))
      },
      unbind(el, binding) {
        window.removeEventListener('resize', _.debounce(binding.value))
      }
    })

    if (['staging', 'production'].includes(process.env.SENTRY_CURRENT_ENV)) {
      Sentry.init({
        dsn:
          'https://fa22e615e4154f5781a29b6517231694@o100084.ingest.sentry.io/5202269',
        integrations: [
          new Integrations.Vue({ Vue, attachProps: true }),
          new Integrations.Dedupe(),
          new Integrations.ExtraErrorData({ depth: 3 })
        ],
        environment: process.env.SENTRY_CURRENT_ENV
      })
    }

    const vueInstances = []
    const vueOptions = {}

    const requireContext = require.context(
      'src/js/customer',
      true,
      /\.vue$|\.js$/
    )

    requireContext.keys().forEach(key => {
      const name = key
        .split('/')
        .pop()
        .split('.')
        .shift()
      vueOptions[name] = requireContext(key).default
    })

    window.addEventListener('DOMContentLoaded', () => {
      const templates = document.querySelectorAll('[data-vue]')

      for (const el of templates) {
        const vm = new Vue(Object.assign(vueOptions[el.dataset.vue], { el }))
        vueInstances.push(vm)
      }
    })

    window.addEventListener('unload', () => {
      for (const vm of vueInstances) {
        vm.$destroy()
      }
      vueInstances.length = 0
    })
  }
}
